export const name = "integro";
export const kind = "application";
export const values = {
  "brand": "Integro",
  "title": "${currentPage.title} | Claims",
  "supportedLocales": [
    {
      "code": "hu",
      "name": "Magyar",
      "default": true
    },
    {
      "code": "en",
      "name": "English",
      "fallback": true
    }
  ],
  "defaultVars": {
    "integro_docs_url": "/docs",
    "integro_api_openapi_json_url": "/api/openapi.json",
    "integro_api_base_url": "",
    "meters_api_openapi_json_url": "/api/openapi.json",
    "meters_api_base_url": "",
    "meter_stats_api_openapi_json_url": "/api/openapi.json",
    "meter_stats_api_base_url": "",
    "waste_bins_api_openapi_json_url": "/api/openapi.json",
    "waste_bins_api_base_url": ""
  }
};

export default {
  name: "integro",
  kind: "application",
  ...values,
};
